import {WarningModal} from "../custom-components/modals/WarningModal.tsx";
import {SearchChannelsModal} from "../custom-components/modals/SearchChannelsModal.tsx";
import {StopCampaignModal} from "../custom-components/modals/StopCampaignModal.tsx";
import {StatisticsPlacementModal} from "../custom-components/modals/StatsPlacementModal.tsx";
import {ShareModal} from "../custom-components/modals/ShareChannelSheet.tsx";
import {StatsFilterModal} from "../custom-components/modals/StatsFilterModal.tsx";
import {ChannelDetailsModal} from "../custom-components/modals/ChannelDetailsModal.tsx";
import {LaunchCampaignModal} from "../custom-components/modals/LaunchCampaignModal.tsx";
import {AvailableChannels} from "../custom-components/modals/AvailableChannels.tsx";
import {useModal} from "../context/ModalContext.tsx";
import {DeclinePublicationModal} from "../custom-components/modals/DeclinePublication.tsx";
import {DeclineActualPublicationModal} from "../custom-components/modals/DeclineActualPublication.tsx";
import {ReferralProgramTerms} from "../custom-components/modals/ReferralProgramTerms.tsx";


export const ModalContainer = () => {
    const {modals} = useModal();

    return (
        <>
            {modals.map(({id, type, props}) => {
                const commonProps = {...props, modalId: id};

                switch (type) {
                    case 'WARNING':
                        return <WarningModal key={id} {...props} />;
                    case 'REFERRAL_STATS_FILTER':
                        return <StatsFilterModal key={id} {...props} applyFilters={commonProps.applyFilters}/>;
                    case 'REFERRAL_PROGRAM_TERMS':
                        return <ReferralProgramTerms key={id} {...props} />;
                    case 'DECLINE_PUBLICATION':
                        return <DeclinePublicationModal key={id} {...props} modalId={commonProps.modalId}/>;
                    case 'DECLINE_ACTUAL_PUBLICATION':
                        return <DeclineActualPublicationModal key={id} {...commonProps} />;
                    case 'AVAILABLE_CHANNELS':
                        return <AvailableChannels key={id} {...commonProps} />;
                    case 'SEARCH':
                        return <SearchChannelsModal key={id} {...props} modalId={commonProps.modalId}
                                                    searchType={props.searchType || 'createCampaign'}/>;
                    case 'LAUNCH_CAMPAIGN':
                        return <LaunchCampaignModal key={id} {...props} modalId={commonProps.modalId}/>;

                    case 'STOP_CAMPAIGN':
                        return <StopCampaignModal key={id} {...commonProps} title={commonProps.title}
                                                  desc={commonProps.desc}/>;
                    case 'STATISTICS_PLACEMENT':
                        return <StatisticsPlacementModal key={id} {...props} />;
                    case 'CHANNEL_DETAILS':
                        return <ChannelDetailsModal key={id} {...props} type={props?.type ?? 'add'}/>;
                    case 'SHARE':
                        return <ShareModal key={id} {...props} />;
                    default:
                        return null;
                }
            })}
        </>
    );
};

